import React from 'react';
import supportImage from '../../../assets/images/Defence/Support/support.png';

const supportStyles = `
.support-section {
  width: 100%;
  background: #ffffff;
  padding-top: 150px;
  padding-bottom: 0;
}

.support-container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 80px;
}

.support-left {
  flex: 1;
  max-width: 620px;
}

.support-left h2 {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  color: #0f172a;
  margin-bottom: 20px;
}

.support-left p {
  font-size: 16px;
  line-height: 1.7;
  font-weight: 500;
  color: #606060;
}

.support-right {
  flex: 1;
  display: flex;
  justify-content: center;
}

.support-right img {
  width: 100%;
  max-width: 600px;
  height: 350px;
  border-radius: 18px;
  object-fit: cover;
  box-shadow: 0 20px 40px rgba(15, 23, 42, 0.15);
}
`;

export default function SupportSection() {
  return (
    <>
      <style>{supportStyles}</style>

      <section className="support-section">
        <div className="support-container">
          <div className="support-left">
            <h2>
              Support That Keeps
              <br />
              Mission Critical Systems Ready
            </h2>

            <p>
              From maintenance and repair to integration and lifecycle support,
              Combat Solutions ensures defence systems perform reliably
              throughout their operational life.
            </p>
          </div>

          <div className="support-right">
            <img src={supportImage} alt="Mission support team" />
          </div>
        </div>
      </section>
    </>
  );
}
